// BUG-15 — Canonical list of public (non-authenticated) routes.
//
// Single source of truth for any code that needs to decide whether the
// current path requires a JWT/session. Previously this list lived as 4
// separate hardcoded copies (AuthProvider, SessionContext, authMonitor,
// useAuthGuard) which drifted: vendor-public pages were added to the
// router but never appended to any of the 4 lists, so unauthenticated
// visitors were always bounced to /.
//
// Keep this in sync with the unguarded <Route> entries in App.js.
// Vendor-portal sub-paths are matched via the prefix helper so we don't
// have to maintain each new sub-path individually.

export const PUBLIC_ROUTES = [
    '/',
    '/terms-and-condition',
    '/privacy-policy',
    '/vendor-signup',          // ARCH-03 — public vendor self-registration
    '/vendor-portal',          // token-gated stage-2 onboarding (handles auth itself)
    '/vendor-portal/chat',     // T2T-05-C6 — vendor chat magic-link page
];

export const isPublicRoute = (path) =>
    PUBLIC_ROUTES.includes(path) || (typeof path === 'string' && path.startsWith('/vendor-portal/'));

const publicRoutesUtil = { PUBLIC_ROUTES, isPublicRoute };
export default publicRoutesUtil;
